/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {SearchFinderRowSkeleton} from "./SearchFinderRowSkeleton";

export const SearchFinderSkeleton = () => (
    <div className="row">{[...Array(3)].map((item, i) => <SearchFinderRowSkeleton key={i}/>)}</div>
)
